import { defineMessages } from 'react-intl';

export default defineMessages({
    ExpirationDateError: {
        id: 'ml.common.directives.MLPriorInsuranceDirectiveCtrl.ExpirationDateError',
        defaultMessage: 'The expiration date on your prior policy is 90 or more days in the past, please select if you were insured on another policy or do not have an insurance policy.'
    },
    LengthWithCurrentCarrierError: {
        id: 'ml.common.directives.MLPriorInsuranceDirectiveCtrl.LengthWithCurrentCarrierError',
        defaultMessage: 'How long have you been with your current carrier? Length must be a number between 0 and 99'
    },
    MilitaryLengthWithPriorCarrierError: {
        id: 'ml.common.directives.MLPriorInsuranceDirectiveCtrl.MilitaryLengthWithPriorCarrierError',
        defaultMessage: 'How long had you been with your prior carrier needs to be a number between 0 and 99.'
    },
    NoCarrierOrNoInsuranceError: {
        id: 'ml.common.directives.MLPriorInsuranceDirectiveCtrl.NoCarrierOrNoInsuranceError',
        defaultMessage: 'Please select current carrier or no insurance in last 90 days.'
    },
    NoCarrierError: {
        id: 'ml.common.directives.MLPriorInsuranceDirectiveCtrl.NoCarrier',
        defaultMessage: 'Please select current carrier.'
    },
    NotListedCarrierInsuredError: {
        id: 'ml.common.directives.MLPriorInsuranceDirectiveCtrl.NotListedCarrierInsuredError',
        defaultMessage: 'Enter Your current carrier. Provider name cannot exceed 40 characters'
    },
    NotListedInsuranceProviderError: {
        id: 'ml.common.directives.MLPriorInsuranceDirectiveCtrl.NotListedInsuranceProviderError',
        defaultMessage: 'Enter Your current carrier. Provider name cannot exceed 40 characters'
    },
    OtherOrNoInsuranceError: {
        id: 'ml.common.directives.MLPriorInsuranceDirectiveCtrl.OtherOrNoInsuranceError',
        defaultMessage: 'Only 1 answer for other or no insurance can be selected'
    },
    PriorInsurance: {
        id: 'ml.quoteandbind.pages.additionalinfo.PriorInsurance',
        defaultMessage: 'Prior Insurance'
    },
    continuousLiabilityMonthsLabel: {
        id: 'ml.common.directives.MLPriorInsurance.continuousLiabilityMonthsLabel',
        defaultMessage: 'Months of Continuous Prior Insurance'
    },
    lengthWithCurrentCarrierTooltip: {
        id: 'ml.quoteandbind.pages.additionalinfo.LengthWithCurrentCarrier_ML.tooltip',
        defaultMessage: 'In years (round down)'
    },
    OriginalEffectiveDate: {
        id: 'ml.quoteandbind.pages.additionalinfo.OriginalEffectiveDate',
        defaultMessage: 'Please enter a valid date in a MM/YYYY format for the Original Effective Date of your prior policy.'
    },
    FutureEffectiveDate: {
        id: 'ml.quoteandbind.pages.additionalinfo.FutureEffectiveDate',
        defaultMessage: 'Original Effective Date of your prior policy cannot be greater than current date.'
    },
    CompanyPolicyNumber: {
        id: 'ml.quoteandbind.pages.additionalinfo.CompanyPolicyNumber',
        defaultMessage: 'Company Policy Number should be less than 25 characters long and be strictly alphanumeric.'
    },
    ActiveMilitaryServiceError: {
        id: 'ml.quoteandbind.pages.additionalinfo.AnswerActiveMilitary',
        defaultMessage: 'Answer Active Military Service Question'
    },
    CurrentLiabilityLimitsLowerRequired: {
        id: 'ml.quoteandbind.pages.additionalinfo.CurrentLiabilityLimitsLowerRequired',
        defaultMessage: 'Answer Current Liability Limit Question'
    },
    MilitaryInsurancePriorToServiceRequired: {
        id: 'ml.quoteandbind.pages.additionalinfo.MilitaryInsurancePriorToServiceRequired',
        defaultMessage: 'Answer Did you have insurance in force prior to your military service Question'
    },
    MilitaryInsuranceAboutPriorToServiceRequired: {
        id: 'ml.quoteandbind.pages.additionalinfo.MilitaryInsuranceAboutPriorToServiceRequired',
        defaultMessage: ' Answer Do you have the details available on your prior insurance coverage'
    },
    MilitaryPriorInsurance: {
        id: 'ml.quoteandbind.pages.additionalinfo.MilitaryPriorInsurance',
        defaultMessage: 'Please Select Prior Insurance Provider'
    },
    yourPriorCarrier: {
        id: 'ml.quoteandbind.pages.additionalinfo.yourPriorCarrier',
        defaultMessage: 'Answer How long had you been with your prior carrier?'
    },
    priorLiabilityLimits: {
        id: 'ml.quoteandbind.pages.additionalinfo.prior liability limits',
        defaultMessage: 'Answer What were your prior liability limits?'
    },
    CompanyPolicyNumberIsNull: {
        id: 'ml.quoteandbind.pages.additionalinfo.companyPolicyNumberIsNull',
        defaultMessage: "Please enter a Policy Number."
    },
});
